// eslint-disable-next-line
const tailwindBaseConfig = require('./tailwindBaseConfig');

module.exports = { tailwindBaseConfig };
